import { createClient } from '@supabase/supabase-js'

// 🔑 Thay bằng thông tin từ Supabase Dashboard → Project Settings → API
const supabaseUrl = 'https://zycopvyogthujudumgzh.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp5Y29wdnlvZ3RodWp1ZHVtZ3poIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA0NTA0MzUsImV4cCI6MjA5NjAyNjQzNX0.AaiquplQC2IaqTybcmH2uo0aatBf7c9o-3Oz7X0gkKk'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)